angular.module('edxComponents')
  .component('edxAfAssignmentShortcut', {
    templateUrl: '/resources/components/assign-focus/af-assignment-shortcut.component/af-assignment-shortcut.component.html',
    controller: [
      'navigation',
      'edxStandardsStateParamParser',
      'dblAnalyticsProvider',
      'configuration',
      'authentication',
      AfAssignmentShortcutController],
    controllerAs: 'vm',
    bindings: {
      level: '<edxLevel',
      domain: '<edxDomain',
      cluster: '<edxCluster',
      analyticCategory: '@edxAnalyticCategory'
    }
  });

function AfAssignmentShortcutController(
  navigation,
  standardsStateParamParser,
  analyticService,
  $configuration,
  dblAuthentication) {
  var vm = this;

  vm.onClick = onClick;
  var customer = dblAuthentication.getCustomer();
  if (!vm.analyticCategory) {
    vm.analyticCategory = 'Assign Focus';
  }

  function onClick() {
    var afStateParams = {
      'assign': 'true',
      'pane': 'create_assignment'
    };

    var standardsParam = standardsStateParamParser.formatCluster(vm.level, vm.domain, vm.cluster);
    if (standardsParam) {
      afStateParams.standards = standardsParam;
      afStateParams.standards = afStateParams.standards.concat(',1f');
      afStateParams.focusType = 'cluster';
    }

    var url  =  !customer.isGuardian() ? 'add-assignment' : '.';
    navigation.go(url, afStateParams);
    if(afStateParams.standards) {
      localStorage.setItem('stateParams', afStateParams.standards);
    }
    analyticService.eventTrack('AF Shortcut Clicked', {
      category: vm.analyticCategory,
      label: standardsParam
    });
  }
}
